// Region (ISO-3166) -> currency. Only regions we plausibly serve; everything
// else falls back to USD. Stripe re-confirms the real tax country at checkout,
// so this only needs to pick a sensible default presentment currency.
const REGION_CURRENCY = {
  US: "usd",
  GB: "gbp",
  CA: "cad",
  AU: "aud",
  NZ: "nzd",
  JP: "jpy",
  CH: "chf",
  SE: "sek",
  NO: "nok",
  DK: "dkk",
  PL: "pln",
  SG: "sgd",
  HK: "hkd",
  MX: "mxn",
  // Euro area
  FR: "eur", DE: "eur", ES: "eur", IT: "eur", NL: "eur", IE: "eur",
  PT: "eur", AT: "eur", BE: "eur", FI: "eur", GR: "eur", LU: "eur",
};

// UI languages that map straight to a currency, regardless of browser region —
// so the FR/ES/DE/IT sites always present in EUR. English is left to region
// detection below (en-GB -> GBP, en-US -> USD, en-CA -> CAD, ...).
const LANGUAGE_CURRENCY = { fr: "eur", es: "eur", de: "eur", it: "eur" };

// `override` (the ?cur= query param) wins over every heuristic: the Google
// Shopping feed links here with the currency it advertised, and a mismatch
// between feed price and landing price gets the product disapproved.
export function detectCurrency(locale, supported, override) {
  const ok = (c) => !supported || supported.length === 0 || supported.includes(c);
  const forced = (override || "").trim().toLowerCase();
  if (forced && ok(forced)) return forced;
  const byLang = LANGUAGE_CURRENCY[(locale || "").slice(0, 2).toLowerCase()];
  if (byLang && ok(byLang)) return byLang;
  const tag = locale && locale.includes("-")
    ? locale
    : (typeof navigator !== "undefined" ? navigator.language : "");
  const region = (tag.split("-")[1] || "").toUpperCase();
  const cur = REGION_CURRENCY[region];
  return cur && ok(cur) ? cur : "usd";
}

// Look up a row from the /api/pricing payload; fall back to USD then first row.
export function formatFromTable(prices, currency) {
  return (
    prices.find((p) => p.currency === currency) ||
    prices.find((p) => p.currency === "usd") ||
    prices[0]
  );
}
